import BaseView from "scripts/views/baseView";
import ForbiddenSyncError from "scripts/exceptions/forbiddenSyncError";
import NotFoundSyncError from "scripts/exceptions/notFoundSyncError";
import SubscriptionSyncError from "scripts/exceptions/subscriptionSyncError";
import { pushFragment } from "scripts/utils/routerHelpers";
import templateErrorPage403 from "templates/errorPage403.hbs";
import templateErrorPage404 from "templates/errorPage404.hbs";
import templateErrorPage500 from "templates/errorPage500.hbs";
import templateErrorPage999 from "templates/errorPage999.hbs";

const chan = Backbone.Radio.channel;

class ErrorPageView extends BaseView {
  get events() {
    return {
      "click #bb-error-page-back-button": "onClickBack",
      "click #bb-error-page-home-button": "onClickHome",
    };
  }

  // constructor(options) {
  //   super(options);
  //
  //   // Commenting this out, because the function doesn't exist [AS]
  //   //chan('display').on('window:resize', this.setMinHeightWinHeight, this);
  // }

  render() {
    const template = this.templateForError();

    this.$el.html(template(this.model.toJSON()));

    return this;
  }

  templateForError() {
    const error = this.model.get("error");

    let template;

    if (error instanceof ForbiddenSyncError) {
      template = templateErrorPage403;
    } else if (error instanceof NotFoundSyncError) {
      template = templateErrorPage404;
    } else if (error instanceof SubscriptionSyncError) {
      template = templateErrorPage999;
    } else {
      chan("bugsnag").request("notify", error);
      template = templateErrorPage500;
    }

    return template;
  }

  onClickBack() {
    const previousFragment = chan("history").request("previousFragment");
    pushFragment(previousFragment ? previousFragment : "/home");
    window.location.reload();
    return false;
  }

  onClickHome() {
    pushFragment("/home");
    window.location.reload();
    return false;
  }
}

export default ErrorPageView;
